import { AppLocale } from "../config/locales"
import dayjs from "dayjs"
import quarterOfYear from "dayjs/plugin/quarterOfYear"
dayjs.extend(quarterOfYear)

export function dateToApiString(d: Date, hasTime?: boolean) {
    if (hasTime) {
        return d.toISOString()
    }
    const apiString = `${d.getFullYear()}-${d.getMonth() + 1 < 10 ? "0" : ""}${d.getMonth() + 1}-${d.getDate() < 10 ? "0" : ""}${d.getDate()}`

    return apiString
}

export const isSameDate = (d1: dayjs.Dayjs, d2: dayjs.Dayjs) => d1.year() === d2.year() && d1.month() === d2.month() && d1.date() === d2.date()
export const replaceDate = (dest: dayjs.Dayjs, source: dayjs.Dayjs) => {
    return dest.year(source.year()).month(source.month()).date(source.date())
}
export const setTime = (dest: dayjs.Dayjs, hours: number, minutes: number) => dest.hour(hours).minute(minutes)

export const HumanizeInterval = (d1: dayjs.Dayjs, d2: dayjs.Dayjs | undefined, locale: AppLocale, fullMonth?: boolean) => {
    if (!d2) return d1.toDate().toLocaleDateString(locale)
    else {
        if (d1.month() === d2.month() && d2.date() === d1.date())
            return d1.toDate().toLocaleDateString(locale, {
                month: fullMonth ? "long" : "numeric",
                day: "numeric",
                year: "numeric",
            })
        else if (d1.month() === d2.month() && d2.date() > d1.date()) {
            const month = d1.locale(locale).format(fullMonth ? "MMMM" : "M") + (!fullMonth ? "." : "")
            return `${d1.date()}. - ${d2.date()}. ${month} ${d1.year()}`
        } else return `${d1.toDate().toLocaleDateString(locale)} - ${d2.toDate().toLocaleDateString(locale)}`
    }
}

export const HumanizeDays = (d1: dayjs.Dayjs, d2: dayjs.Dayjs | undefined, locale: AppLocale, fullMonth = true) => {
    if (!d2 || (d1.month() === d2.month() && d2.date() === d1.date()))
        return {
            line1: d1.format("D") + (fullMonth ? "" : `. ${d1.locale(locale).format("M")}.`),
            line2: `${fullMonth ? d1.locale(locale).format("MMMM") + " " : ""}${d1.format("YYYY")}`,
        }
    else {
        if (d1.month() === d2.month() && d2.date() !== d1.date())
            return {
                line1: `${d1.format("D")}. - ${d2.format("D")}.${fullMonth ? "" : " " + d1.locale(locale).format("M") + "."}`,
                line2: `${fullMonth ? d1.locale(locale).format("MMMM") + " " : ""}${d1.format("YYYY")}`,
            }
        else if (d1.month() !== d2.month())
            return {
                line1: `${d1.format("D.M")}. - ${d2.format("D.M")}.`,
                line2: `${d1.format("YYYY")}`,
            }
    }
}

declare global {
    interface Date {
        addDays(days: number): Date
        trimTime(): Date
        toApiString(): string
    }
}
Date.prototype.toApiString = function (): string {
    return dateToApiString(this)
}
Date.prototype.addDays = function (days: number): Date {
    const newDate = new Date(this)
    newDate.setDate(newDate.getDate() + days)
    return newDate
}
Date.prototype.trimTime = function (): Date {
    const newDate = new Date(this)
    newDate.setHours(0)
    newDate.setMinutes(0)
    newDate.setSeconds(0)
    newDate.setMilliseconds(0)
    return newDate
}
